export default "__VITE_ASSET__B9W_LUQt__"